<template>
  <div>
    <div class="filter">
      <h2>Filter or Search</h2>
      <members-chapter-filter :chapters="chapters" @chaptersChanged="updateChapters" :name-for-global="'Global Directors'"></members-chapter-filter>
      <search-filter @searchChanged="updateSearch"></search-filter>
   </div>
    <div class="member-list">

        <vue-simple-spinner v-if="showSpinner" size="large" class="spinner" ></vue-simple-spinner>

        <member-list :items="peopleToShow" :loading="showSpinner" :chapters="chapters"></member-list>

        <nav class="icota_pagination">
              <v-pagination v-if="totalPages && totalPages!=1 && !showSpinner"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :classes="paginationClasses"
                            :labels="paginationAnchorTexts"
                            @change="updatePeopleToShow(false)">
              </v-pagination>
        </nav>
    </div>
  </div>
</template>

<script>

  import VueSimpleSpinner from 'vue-simple-spinner';
  import vPagination from 'vue-plain-pagination';

  export default {

        data() {
          return {
              chaptersSelected: [],
              search:'',
              showSpinner: true,
              allPeople: [],
              peopleToShow: [],
              meta: [],
              currentPage: 1,
              totalPages: 1,
              membersPerPage: 50,
              paginationClasses: {
                ul: 'pagination__list',
                li: 'pagination__group',
                liDisable: 'disabled',
                button: 'pagination__item',
                buttonActive: 'pagination__item_active',
              },
              paginationAnchorTexts: {
                first: 'First',
                prev: 'Prev',
                next: 'Next',
                last: 'Last'
              },
          }
        },

        props:['chapters','years'],

        components: {
          VueSimpleSpinner,
          vPagination
        },

        mounted(){


      const query =
        `{
            users(group:"chapterMember",showInMembersDirectory:true,expiryDate:["> now"]) {
              ... on User {
                id,
                companyName,
                firstName,
                lastName,
                membershipChapter {
                  id
                }
              }
            }
          }`;


        window.axios.post('/api', {query: query}, {headers: {Authorization: window.membersToken}})
        .then(response => {
          let people = response.data.data.users;
          people = people.filter((person)=>person.lastName).sort((a,b)=>a.lastName.localeCompare(b.lastName));
          this.allPeople = people;
          this.updatePeopleToShow(true);
          this.showSpinner = false;
          });
        },

        methods: {
          updateChapters(chapters){
              this.currentPage = 1;
              this.chaptersSelected = chapters;
              this.updatePeopleToShow(false);
          },
          updateSearch(search) {
              this.currentPage = 1;
              this.search = search;
              this.updatePeopleToShow(false);
          },
          updatePeopleToShow(initialLoad){
             if (!initialLoad) {
                document.querySelector('.member-list').scrollIntoView({
                  behavior: "smooth"
                });
              }
              var potentialPeopleToShow = this.allPeople;

              // chapters
              if (this.chaptersSelected.length) {
                potentialPeopleToShow = potentialPeopleToShow.filter((person)=>{
                  var personsChapter = 0;
                  if (person.membershipChapter.length) { personsChapter = parseInt(person.membershipChapter[0].id) }
                  return this.chaptersSelected.includes(personsChapter);
                });
              }

              //search terms
              if (this.search.length) {
                potentialPeopleToShow = potentialPeopleToShow.filter((person)=>{
                  if (!person.companyName) { person.companyName = ''; }
                  return (person.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
                    person.lastName.toLowerCase().includes(this.search.toLowerCase()) ||
                    person.companyName.toLowerCase().includes(this.search.toLowerCase()));
                });
              }

              this.totalPages = Math.ceil(potentialPeopleToShow.length/this.membersPerPage);

              const startAt = (this.currentPage*this.membersPerPage)-this.membersPerPage;
              const endAt = this.currentPage*this.membersPerPage;

              this.peopleToShow = potentialPeopleToShow.slice(startAt,endAt);
          },
        }
    }


</script>
